import React from 'react';
import '../styles/Loading.css';
import loading from "../assets/loading.svg";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-card">
        <div className="spinner">
          <img src={loading} alt="Loading" />
        </div>
        <div className="loading-title">Garcon Venue hazırlanıyor</div>
        <div className="loading-text">Operasyon verileri yükleniyor.</div>
      </div>
    </div>
  );
};

export default Loading;
